 const menuData = [
    {
      "title": "More information",
      "links": [
        { "label": "Contact us", "url": "/contact" },
        { "label": "About", "url": "/about" },
        { "label": "Find a rental location", "url": "/" } 
      ]
    },
    {
      "title": "Business center",
      "links": [
        { "label": "Business solutions", "url": "/" },
        { "label": "Tour operators", "url": "/" },
        { "label": "Travel agents", "url": "/" }
      ]
    },
    {
        "title": "Europcar Mobility Group",
        "links": [
          { "label": "Careers", "url": "/" },
          // { "label": "Goldcar", "url": "/" },
          { "label": "Europcar On Demand", "url": "/" },
          { "label": "FOX Rent A Car", "url": "/" } 
        ]
      },
      {
        "title": "Legal Information",
        "links": [
          { "label": "Privacy Policy", "url": "/privacy-policy" },
          { "label": "Terms And Conditions", "url": "/terms-and-conditions" },
          { "label": "Cancellation And Refund", "url": "/cancellation-and-refund" },
          
        ]
      }
  ]

  export default menuData;
  
  